import { find } from 'lodash';

export const getAvatarPropertyValue = (
    properties: {
        name: string;
        value: string;
    }[],
    key: string,
) => find(properties, ({ name }) => name === key)?.value;

export const getAvatarPropertyId = (
    properties: {
        name: string;
        value: string;
        id: string;
    }[],
    key: string,
) => find(properties, ({ name }) => name === key)?.id;
